import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93534be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-history" }
const _hoisted_2 = { class: "history-actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lich-su-tat-ca-ngay" }, "Tất cả ngày của khoa/phòng", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "history-actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Chưa có lịch sử chia giờ trong phạm vi đã chọn.")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Chưa xuất file từ lần chia giờ này.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Checkbox, {
        modelValue: _ctx.allDates,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.allDates) = $event)),
        binary: true,
        inputId: "lich-su-tat-ca-ngay"
      }, null, 8, ["modelValue"]),
      _hoisted_3,
      (!_ctx.allDates)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.ngay ? _ctx.moment(_ctx.ngay).format('DD/MM/YYYY') : 'Chọn ngày chấm công để lọc'), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        label: "Tải lại lịch sử",
        icon: "pi pi-refresh",
        class: "p-button-text",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tai())),
        disabled: _ctx.loading || _ctx.busy
      }, null, 8, ["disabled"])
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.items,
      loading: _ctx.loading,
      lazy: "",
      paginator: "",
      rows: 10,
      first: _ctx.page*10,
      totalRecords: _ctx.total,
      onPage: _cache[2] || (_cache[2] = event=>_ctx.doiTrang(event.page)),
      showGridlines: "",
      stripedRows: "",
      tableStyle: {minWidth:'1050px'}
    }, {
      empty: _withCtx(() => [
        _hoisted_6
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "id",
          header: "Lần chia"
        }),
        _createVNode(_component_Column, { header: "Ngày thực hiện" }, {
          body: _withCtx((row) => [
            _createTextVNode(_toDisplayString(_ctx.moment(row.data.ngayThucHien).format('DD/MM/YYYY')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "taiKhoan",
          header: "Tài khoản chia giờ"
        }),
        _createVNode(_component_Column, { header: "Thời gian lưu" }, {
          body: _withCtx((row) => [
            _createTextVNode(_toDisplayString(_ctx.utc(row.data.thoiGianTaoUtc)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "soDaXep",
          header: "Đã xếp"
        }),
        _createVNode(_component_Column, {
          field: "soChuaXep",
          header: "Chưa xếp"
        }),
        _createVNode(_component_Column, {
          field: "soLanXuat",
          header: "Số lần xuất"
        }),
        _createVNode(_component_Column, { header: "Tra cứu" }, {
          body: _withCtx((row) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                label: "Xem kết quả",
                class: "p-button-text",
                onClick: ($event: any) => (_ctx.doc(row.data.id,false)),
                disabled: _ctx.busy
              }, null, 8, ["onClick", "disabled"]),
              _createVNode(_component_Button, {
                label: "Xuất lại Excel",
                icon: "pi pi-file-excel",
                class: "p-button-text",
                onClick: ($event: any) => (_ctx.xuat(row.data.id)),
                disabled: _ctx.busy
              }, null, 8, ["onClick", "disabled"]),
              _createVNode(_component_Button, {
                label: "Nhật ký xuất",
                class: "p-button-text",
                onClick: ($event: any) => (_ctx.doc(row.data.id,true)),
                disabled: _ctx.busy
              }, null, 8, ["onClick", "disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "first", "totalRecords"]),
    _createVNode(_component_Dialog, {
      class: "workflow-dialog",
      visible: _ctx.showExports,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showExports) = $event)),
      header: 'Nhật ký tạo file Excel — lần chia '+_ctx.selectedId,
      modal: "",
      style: _normalizeStyle({width:'min(850px,95vw)'})
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.exports,
          paginator: "",
          rows: 10,
          showGridlines: ""
        }, {
          empty: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "taiKhoan",
              header: "Tài khoản xuất"
            }),
            _createVNode(_component_Column, { header: "Thời gian xuất" }, {
              body: _withCtx((row) => [
                _createTextVNode(_toDisplayString(_ctx.utc(row.data.thoiGianXuatUtc)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Báo cáo" }, {
              body: _withCtx((row) => [
                _createTextVNode(_toDisplayString(row.data.loaiBaoCao==='TheoNhanVien'?'Lịch nhân viên':'Tổng hợp'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Nhân viên" }, {
              body: _withCtx((row) => [
                _createTextVNode(_toDisplayString(row.data.loaiBaoCao==='TheoNhanVien' ? (row.data.tenNhanVien || 'Tất cả nhân viên') : '—'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "header", "style"])
  ]))
}